import { featuredEvents } from "@/mocks/home";

export default function CardFlow() {
  return (
    <section id="flow" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-medium tracking-widest text-accent-600">FEATURED FLOW</p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              大图选读 · 本周重点事件
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            只挑讨论最集中的几件事展开，配图克制，重点放在标题与线索本身。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredEvents.map((event, idx) => (
            <article
              key={event.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 animate-fade-up"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              <div className="relative w-full h-[200px] md:h-[210px] overflow-hidden">
                <img
                  src={event.image}
                  alt={`${event.title} 黑料看料盘点`}
                  title={`${event.title} 黑料看料一览`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-medium text-foreground-800">
                  {event.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base md:text-[17px] font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {event.title}
                </h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-foreground-600">
                  {event.summary}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  {event.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line" />
                    {event.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-eye-line" />
                    {event.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}